exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!vodal/common.css"), "");
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!vodal/slide-down.css"), "");

// module
exports.push([module.id, "\n.btn-primary[data-v-60414322] {\n    color: #FFF !important;\n}\n.state[data-v-60414322] {\n    padding-bottom: 10px;\n    \n    color: #888;\n}\n.state .active[data-v-60414322] {\n    color: #451493;\n}\n#amount[data-v-60414322] {\n    width: 150px;\n    margin-right: 20px;\n}\n#calc[data-v-60414322] {\n    font-size: 50;\n}\n", ""]);

// exports
